import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="bg-black py-4 px-4 text-center" data-id="element-68">
      <div className="max-w-4xl mx-auto" data-id="element-69">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-2" data-id="element-70">
          ¿Listo/a para transformar tu año en Psicología?
        </h2>
        <p className="text-xl text-gray-300 mb-3" data-id="element-71">
          Sumate a docentes que ya dejaron de improvisar.
        </p>
      </div>
    </section>;
}